export const NEWS_ARTICLE_SEO = {
  'ag-they': {
    en: {
      title: 'AG: "They See Us Now" available on all platforms',
      description: "The anthem of Skoletoon's is now available to stream on all major platforms.",
    },
    fr: {
      title: 'AG : "They See Us Now" disponible sur toutes les plateformes',
      description:
        "L'hymne de l'univers Skoletoon's est désormais disponible sur toutes les plateformes.",
    },
    es: {
      title: 'AG: "They See Us Now" disponible en todas las plataformas',
      description:
        "El himno del universo Skoletoon's ya esta disponible en las principales plataformas.",
    },
    pt: {
      title: 'AG: "They See Us Now" disponivel em todas as plataformas',
      description: "O hino do universo Skoletoon's ja esta disponivel nas principais plataformas.",
    },
    ar: {
      title: 'AG: "They See Us Now" متاحة على كل المنصات',
      description: "نشيد عالم Skoletoon's أصبح متاحا على المنصات الرئيسية.",
    },
    hi: {
      title: 'AG: "They See Us Now" सभी platforms पर उपलब्ध',
      description: "Skoletoon's का anthem अब प्रमुख streaming platforms पर उपलब्ध है.",
    },
    zh: {
      title: 'AG："They See Us Now" 已上线各大平台',
      description: "Skoletoon's 宇宙的主题声音现已上线主要平台。",
    },
    id: {
      title: 'AG: "They See Us Now" tersedia di semua platform',
      description: "Anthem universe Skoletoon's kini tersedia di platform utama.",
    },
    ru: {
      title: 'AG: "They See Us Now" доступен на всех платформах',
      description:
        "Гимн вселенной Skoletoon's теперь доступен на основных стриминговых платформах.",
    },
    sw: {
      title: 'AG: "They See Us Now" inapatikana kwenye platforms zote',
      description: "Anthem ya ulimwengu wa Skoletoon's sasa inapatikana kwenye platforms kuu.",
    },
  },
} as const;

export type NewsArticleSeoLanguage = keyof (typeof NEWS_ARTICLE_SEO)['ag-they'];

export function getNewsArticleSeo(slug: string | undefined, language: NewsArticleSeoLanguage) {
  if (slug !== 'ag-they') return null;
  return NEWS_ARTICLE_SEO['ag-they'][language] ?? NEWS_ARTICLE_SEO['ag-they'].fr;
}
